import { Link } from '@tanstack/react-router'

interface NavLinkProps {
  to: string
  children: React.ReactNode
  external?: boolean
  className?: string
  onClick?: () => void
  search?: Record<string, unknown>
}

/**
 * Reusable navigation link with consistent styling and active state
 */
export function NavLink({
  to,
  children,
  external = false,
  className = '',
  onClick,
  search,
}: NavLinkProps) {
  const baseClasses =
    'inline-flex min-h-11 items-center text-sm font-medium text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] transition-[color,background-color] duration-300 ease-brisk focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-primary/50 rounded-full'

  if (external) {
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        className={`${baseClasses} ${className}`}
        onClick={onClick}
      >
        {children}
      </a>
    )
  }

  return (
    <Link
      to={to}
      search={search}
      className={`${baseClasses} ${className}`}
      onClick={onClick}
      activeProps={{
        className: 'text-primary font-semibold hover:text-primary',
      }}
      activeOptions={{ exact: false }}
    >
      {children}
    </Link>
  )
}
